module.exports = __webpack_public_path__ + "img/logo-tikkie-800.f201ff41.png";